/**
 * M249. Belt-fed 5.56 mm: a hundred rounds before a five-second reload, a wide hip cone, and a
 * pattern long enough that the whole box walks somewhere.
 */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const M249 = {
  id: 'm249',
  label: 'M249',
  classId: 'lmg',
  caliber: '5.56x45 mm',
  fireMode: 'auto',
  roundsPerMinute: 850,
  magSize: 100,
  reserveAmmo: 200,
  reloadSeconds: 5,
  emptyReloadSeconds: 5.6,
  reloadStyle: 'magazine',
  damage: 32,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 70, zeroMetres: 320, minScale: 0.5 },
  pellets: 1,
  adsSpreadMoa: 5,
  hipSpreadMoa: 170,
  bloomMoaPerShot: 4,
  bloomMoaCap: 70,
  bloomDecayMoaPerSecond: 60,
  moveSpreadMoaPerMps: 45,
  crouchSpreadScale: 0.5,
  airborneSpreadMoa: 140,
  recoilPattern: [
    { pitch: 0.8, yaw: 0.1 },
    { pitch: 0.76, yaw: 0.2 },
    { pitch: 0.72, yaw: 0.3 },
    { pitch: 0.7, yaw: 0.36 },
    { pitch: 0.66, yaw: 0.28 },
    { pitch: 0.62, yaw: 0.12 },
    { pitch: 0.6, yaw: -0.08 },
    { pitch: 0.58, yaw: -0.24 },
    { pitch: 0.56, yaw: -0.36 },
    { pitch: 0.54, yaw: -0.4 },
    { pitch: 0.52, yaw: -0.3 },
    { pitch: 0.5, yaw: -0.14 },
    { pitch: 0.5, yaw: 0.04 },
    { pitch: 0.48, yaw: 0.2 },
    { pitch: 0.46, yaw: 0.32 },
    { pitch: 0.44, yaw: 0.36 },
  ],
  recoilResetSeconds: 0.35,
  recoilRecoveryPerSecond: 6,
  adsFovDegrees: 50,
  adsSeconds: 0.42,
  adsSensitivityScale: 0.65,
  muzzleVelocity: 915,
} as const satisfies WeaponSpec;
